// animationVariants.js
export const animationVariants = {
    enter: (direction) => ({
        x: direction === 'forward' ? 50 : -50,
        opacity: 0
    }),
    center: {
        x: 0,
        opacity: 1
    },
    exit: (direction) => ({
        x: direction === 'forward' ? -50 : 50,
        opacity: 0
    })
};
